import React from "react";

import "../styles/Intro.css";
import Typist from "react-typist";
import "react-typist/dist/Typist.css";
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";
import FadeInSection from "./FadeInSection";
import FractalTree from "./FractalTree";

class Intro extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
      visible: true,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey,
    });
  }

  render() {
    return (
      <div id="intro">
        <FractalTree />

        {/* Text block (title goes above summary) */}
        <div className="intro-block">
          <Typist avgTypingDelay={120}>
            <span className="intro-title">
              {"hi, "}
              <span className="intro-name">{"OMAR"}</span>
              {" here."}
            </span>
          </Typist>

          <FadeInSection>
            <div className="intro-subtitle">I find what others miss.</div>

            <div className="intro-desc">
              I am a Security Researcher and Offensive Security Engineer specializing in vulnerability research, AI security, and penetration testing. I dissect complex architectures, hunt high-impact zero-days (such as in the Go standard library and Apple WebKit), and break software before adversaries do.
            </div>

            <a href="mailto:omar.abdelsalam@gmail.com" className="intro-contact">
              <EmailRoundedIcon />
              {" Say hi!"}
            </a>
          </FadeInSection>
        </div>
      </div>
    );
  }
}

export default Intro;
